<template>
  <div class="table-data">
    <!-- 搜索 -->
    <div class="search-box">
      <el-button
        class="primary-search-btn"
        type="primary"
        @click="add()"
        size="mini"
        >新增</el-button
      >
    </div>
    <!-- 列表 -->
    <!-- content -->
    <el-table :data="tableData" style="width:100%" :height="tHeight" class="table-box">
      <el-table-column prop="roleId" label="角色编号" width="300" align="center"></el-table-column>
      <el-table-column label="角色名称" prop="roleName" width="200" align="center"></el-table-column>
      <el-table-column label="权限字符" prop="roleCode" width="200" align="center"></el-table-column>
      <el-table-column label="角色备注信息" prop="remark" width="200" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click="roledelete(scope.row.roleId)"
            size="small"
            type="text"
            >删除</el-button
          >
           <el-button
            @click="modify(scope.row)"
            size="small"
            type="text"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" ref="page-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[5, 7, 10, 15, 20]"
        :current-page.sync="page"
        :page-size="10"
        layout="total,sizes,prev,pager,next,jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 新增修改区域 -->
    <el-dialog :title="isEdit?'修改角色':'新增角色'"
      :visible.sync="modal"
      :close-on-click-modal="false">
      <el-form :inline="true"
          label-width="200px"
          style="text-align:center"
          class="dialog-hei" ref="formItem"  :rules="newRuler" :model="formItem">
        <div style="height:400px;padding: 20px 0 0 0;">
          <el-form-item label="角色名称:"  prop="roleName">
            <div class="d-i-b">
                <el-input v-model="formItem.roleName" placeholder="请输入角色名称" style="width:160px"></el-input>
                </el-input>
              </div>
              
          </el-form-item>
          <el-form-item label="权限字符:" prop="roleCode">
              <el-input v-model="formItem.roleCode" placeholder="请输入用户名称" style="width:160px"></el-input>
          </el-form-item>
          <el-form-item label="备注:" prop="remark">
              <el-input v-model="formItem.remark" placeholder="请输入备注" style="width:160px"></el-input>
          </el-form-item>
          <div>
            <el-form-item label="角色:">
              <div style="height:210px;overflow:auto;width:200px;text-align:center;line-height;">
                <el-tree
                  v-if="openPanel" 
                  :props="props"
                  :data="tree"
                  ref="origintree1"
                  node-key="id"
                  :default-checked-keys="idList"
                  show-checkbox>
                </el-tree>
              </div>
          </el-form-item>
          </div>
        </div>
      </el-form>
      <div slot="footer">
        <el-button type="text" @click="modal = false">取消</el-button>
        <el-button type="primary" @click="ok('formItem')" :loading="loading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template> 
<script>
// import { rolelist,treeall,getRoleDetail,roleadd,roleupdate,roledelete} from '@/api/jurisdiction';
import { Loading } from "element-ui";
export default {
  data() {
    return {
      loading: false,
      load: true,
      isEdit: false,
      modal: false,
      tableData: [],
      total: 0,

      // 
      page: 0,
      size: 10,
      tHeight: document.body.offsetHeight - 230,
      openPanel:false,
      newRuler:{
        roleName:[{required: true, message: '请输入角色名称', trigger: 'blur'}],
        roleCode:[{required: true, message: '请输入权限字符', trigger: 'blur'}],
        remark:[{ required: true, message: '请输入备注', trigger: 'blur' }]
      },
      idList:[], //默认勾选的树id
      formItem:{ //新增角色
          roleName:'',
          roleCode:'',
          remark:'',
          resourceIds:[], 
      },
      props: {
        children: 'children',
        label: 'text'
      },
      tree: [],
    };
  },
  created() {
    this.getTableList();
    this.treeall();
    this.tHeight = document.body.offsetHeight - 230;
  },
  methods: {
    async getTableList() {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.4)",
        text: "加载中...",
      });
      let res =  await rolelist();
      this.tableData = res?res:[];
      this.total = res.length?res.length:0;
      loadingInstance.close();
    },
    async treeall() {
      let res =  await treeall();
      this.tree = res.children?res.children:[];
    },
    handleSizeChange(val) {
      this.page = 1;
      this.getTableList();
    },
    // 点击页数
    handleCurrentChange(val) {
      this.page = val;
      // this.searchData.pageNum = (this.page - 1) * this.searchData.pageSize;
      this.getTableList();
    },
    // 递归循环
    iteration(data) {
      for (var j = 0; j < data.length; j++) {
        if(data[j].selected == true){
          let aa =  data[j].id; 
          this.idList.push(aa);
        }
        if (data[j].children != null && data[j].children.length > 0) {
          this.iteration(data[j].children)
        }
      }
    },
    //修改状态
    roledelete(userId){
      this.$confirm("确定删除当前数据么？", "删除", {
        type: "warning",
      })
        .then(() => {
          let res = roledelete({roleId:userId});
          this.$message({
              type:'success',
              message:'删除成功'
          });
          setTimeout(() => {
            this.getTableList();
          }, 300);
          
        })
        .catch((e) => {
          console.log(e);
        });
      
    },
    add() { //添加角色信息
      this.formItem ={};
      this.idList = [];
      this.treeall();
      this.openPanel = true;
      this.modal = true;
      this.isEdit = false;
      console.log(this.idList);    
    },
    async modify(list){ //修改角色信息
      this.idList = [];
      let res =  await getRoleDetail({roleId:list.roleId}); 
      this.iteration(res.resources.children);
      this.openPanel = true
      this.modal = true
      this.isEdit = true
      this.formItem = list
      this.$nextTick(() => {
        this.$refs.origintree1.setCheckedKeys(this.idList);
      });
      console.log(this.idList);
    },
    ok(formName) { //更新角色信息
      this.$refs[formName].validate(async valid => {
          if (!valid) return;
          this.formItem.resourceIds = this.$refs.origintree1.getCheckedKeys().concat(this.$refs.origintree1.getHalfCheckedKeys());
          console.log(this.formItem.resourceIds);
        if(this.isEdit){
          let newlist = { //更新的信息
            resourceIds:this.formItem.resourceIds,
            roleName:this.formItem.roleName,
            roleCode:this.formItem.roleCode,
            remark:this.formItem.remark,
            roleId:this.formItem.roleId,
          }             
          let res = roleupdate(newlist);
          this.modal = false;
          this.$message({
              type:'success',
              message:'修改成功'
          });
          setTimeout(() => {
            this.getTableList();
          }, 300);
        }else{
          let res = roleadd(this.formItem);
          this.modal = false;
          this.$message({
              type:'success',
              message:'新增成功'
          });
          setTimeout(() => {
            this.getTableList();
          }, 300);
        }
      })
    },
    cancel() {
      this.modal = false;
      this.openPanel = false;
      this.$refs["formItem"].resetFields();
      this.$Message.info("操作取消");
    },
  },
};
</script>

<style lang="scss">
.el-tree__empty-text {
  position:static;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  color: #909399;
  font-size: 14px;
}
</style>